/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  standalone: false,
  selector: 'gh-system-vars-accounts-tab',
  templateUrl: 'system-vars-accounts-tab.component.html',
})
export class SystemVarsAccountsTabComponent {
  constructor(public userContext: BuilderUserContext) {
  }
}
